import React from "react";
import ReactDOM from "react-dom/client";

import "./index.css";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { I18nextProvider } from "react-i18next";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { ThemeModeProvider } from "./contexts/themeModeContext";
import { UserProvider } from "./contexts/userContext";
import { getStoredLang, initI18n } from "./i18n";

(async () => {
    const queryClient = new QueryClient();
    const storedLang = getStoredLang();
    const i18n = await initI18n(storedLang);

    ReactDOM.createRoot(document.getElementById("root")!).render(
        <React.StrictMode>
            <ThemeModeProvider>
                <QueryClientProvider client={queryClient}>
                    <BrowserRouter>
                        <UserProvider>
                            <I18nextProvider i18n={i18n}>
                                <App />
                            </I18nextProvider>
                        </UserProvider>
                    </BrowserRouter>
                </QueryClientProvider>
            </ThemeModeProvider>
        </React.StrictMode>
    );
})();
